import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=05157416&scoped=true&"
import script from "./selectRegion.vue?vue&type=script&lang=js&"
export * from "./selectRegion.vue?vue&type=script&lang=js&"
import style0 from "./selectRegion.vue?vue&type=style&index=0&id=05157416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05157416",
  null
  
)

export default component.exports